import { render, staticRenderFns } from "./r-tile-panel.vue?vue&type=template&id=8e33e24e"
import script from "./r-tile-panel.vue?vue&type=script&lang=js"
export * from "./r-tile-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e33e24e')) {
      api.createRecord('8e33e24e', component.options)
    } else {
      api.reload('8e33e24e', component.options)
    }
    module.hot.accept("./r-tile-panel.vue?vue&type=template&id=8e33e24e", function () {
      api.rerender('8e33e24e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-tile-panel.vue"
export default component.exports